import type { GetCampaignLaunchReadinessQueryResponse } from '../generated/types/GetCampaignLaunchReadiness'

export type { GetCampaignSettingsQueryResponse as CampaignSettings } from '../generated/types/GetCampaignSettings'
export type { GetCampaignScheduleQueryResponse as CampaignSchedule } from '../generated/types/GetCampaignSchedule'
export type { GetCampaignInsightsQueryResponse as CampaignInsightsResponse } from '../generated/types/GetCampaignInsights'
export type { GetCampaignLaunchReadinessQueryResponse as CampaignLaunchReadiness } from '../generated/types/GetCampaignLaunchReadiness'
export type { GetCampaignStatsQueryResponse as CampaignStats } from '../generated/types/GetCampaignStats'

/** Default launch-readiness shown before a campaign is linked to EmailBison (404 fallback). */
export function getDefaultCampaignLaunchReadiness(
  campaignId: number
): GetCampaignLaunchReadinessQueryResponse {
  return {
    campaign_id: campaignId,
    bison_campaign_id: null,
    status: 'draft',
    sequence: {
      is_complete: false,
      step_count: 0,
      description: 'No steps configured',
    },
    leads: { is_complete: false, count: 0, description: 'No leads synced' },
    sender_emails: {
      is_complete: false,
      count: 0,
      disconnected_emails: [],
      description: 'No sender emails attached',
    },
    schedule: { is_complete: false, description: 'No schedule configured' },
    all_complete: false,
  }
}
